export default "__VITE_ASSET__08aca9cc__"